export default "__VITE_ASSET__BkXIsVE$__"